import { render, staticRenderFns } from "./DeliverInfo.vue?vue&type=template&id=5ec05ee0&"
import script from "./DeliverInfo.vue?vue&type=script&lang=js&"
export * from "./DeliverInfo.vue?vue&type=script&lang=js&"
import style0 from "./DeliverInfo.vue?vue&type=style&index=0&scoepd=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports